import { z } from 'zod';

export const MessageType = z.enum([
  'simplr-initiate-chat',
  'show-embedded',
  'show-embedded-transition-complete',
  'show-fullscreen',
  'show-fullscreen-transition-complete',
  'transition-to-normal',
  'transition-to-fullscreen',
]);
